<template>
  <header class="h-header">
    <div class="logo-image">
      <img :src="getLogo(logoName)" alt="logo">
    </div>
  </header>
</template>
<script>
export default {
  name: 'HHeader',
  data() {
    return {
      logoName: (process.env.VUE_APP_COIN_IMAGE_PREFIX||'')+'h365-logo.png',
    }
  },
  methods:{
    getLogo(name) {
      try {
        const images = require.context('../../assets/image/', false, /\.png$/)
        return images('./' + name )
      }
      catch {
        return ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.h-header {
  height: 48px;
  padding: 8px;
  text-align: center;
  .logo-image {
    height: 28px;
    img {
      height: 100%;
    }
  }
}
</style>